'use client';

import useEventCallback from '@mui/utils/useEventCallback';
import type { ChartPlugin } from '../../models';
import type {
  UseChartSeriesConfigSignature,
  SerializeIdentifierFunction,
  CleanIdentifierFunction,
} from './useChartSeriesConfig.types';
import { serializeIdentifier as serializeIdentifierFn } from './utils/serializeIdentifier';
import { cleanIdentifier as cleanIdentifierFn } from './utils/cleanIdentifier';
import type { ChartSeriesConfig } from './types';

export const useChartSeriesConfig: ChartPlugin<UseChartSeriesConfigSignature> = ({ store }) => {
  const serializeIdentifier: SerializeIdentifierFunction = useEventCallback((identifier) =>
    serializeIdentifierFn(store.state.seriesConfig.config, identifier),
  );

  const cleanIdentifier: CleanIdentifierFunction = useEventCallback(function cleanIdentifier(
    identifier: Parameters<CleanIdentifierFunction>[0],
  ) {
    return cleanIdentifierFn(store.state.seriesConfig.config, identifier);
  });

  return {
    instance: {
      serializeIdentifier,
      cleanIdentifier,
    },
  };
};

useChartSeriesConfig.params = {
  seriesConfig: true,
};

useChartSeriesConfig.getDefaultizedParams = ({ params }) => ({
  ...params,
  seriesConfig: params.seriesConfig ?? ({} as ChartSeriesConfig<any>),
});

useChartSeriesConfig.getInitialState = ({ seriesConfig }) => {
  return {
    seriesConfig: {
      config: seriesConfig,
    },
  };
};
